import AllVideosTableContainer from './AllVideosTableContainer';

export default AllVideosTableContainer;
